class Map {
	mapOptions1 = {
		center: new google.maps.LatLng(47.062287, 8.523053),
		zoom: 16,
		mapTypeControl: false,
		streetViewControl: false,
		draggable: false,
		scrollwheel: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	};

	constructor($el) {
		this.$el = $el;

		this.map = new google.maps.Map(this.$el[0], this.mapOptions1);
		this.map.set('styles', [
			{
				featureType: 'administrative',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#444444' }],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry.fill',
				stylers: [{ color: '#f2f2f2' }],
			},
			{
				featureType: 'poi',
				elementType: 'all',
				stylers: [{ visibility: 'off' }],
			},
			{
				featureType: 'road',
				elementType: 'all',
				stylers: [{ saturation: -100 }, { lightness: 45 }],
			},
			{
				featureType: 'road.highway',
				elementType: 'all',
				stylers: [{ visibility: 'simplified' }],
			},
			{
				featureType: 'road.arterial',
				elementType: 'labels.icon',
				stylers: [{ visibility: 'off' }],
			},
			{
				featureType: 'transit',
				elementType: 'all',
				stylers: [{ visibility: 'off' }],
			},
			{
				featureType: 'water',
				elementType: 'all',
				stylers: [{ color: '#d1d1d1' }, { visibility: 'on' }],
			},
		]);

		new google.maps.Marker({
			map: this.map,
			position: new google.maps.LatLng(47.062287, 8.523053),
			draggable: false,
			clickable: false,
			icon: 'upload/layout/icons/marker.png',
		});
	}
}

export default Map;
